import {useService} from '@cindedi/react-application';
import {truncate} from '@cindedi/utilities/truncate';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface EncontrosLoaderData {
  conventions: Event.PublicConventionDto[];
}

export const meta: MetaFunction = function EncontrosMeta({matches}) {
  return seoMeta('encontros', {title: 'Encontros do CINDEDI - Cindedi', description: 'Reviva os encontros do CINDEDI ao longo dos anos! Confira nossa programação e participe das iniciativas que promovem a educação e pesquisa.'}, matches);
};

export const loader: LoaderFunction = async function EncontrosLoader({context: {use}}) {
  const Convention = use('Convention');

  const conventions = await Convention.all();

  return json({
    conventions: conventions.sortBy('startsAt'),
  });
};

export default function EncontrosView() {
  const {conventions} = useLoaderData<EncontrosLoaderData>();
  useService('organization/titlebar').setTitle('Encontros do CINDEDI');

  return (
    <PublicLayout>
      <ul role="list" className="flex flex-col gap-2">
        {conventions.map((convention) => (
          <li key={convention.id} className="hover:bg-shade-3 bg-shade-2 rounded">
            <Link to={`/encontros/${convention.slug}`} key={convention.id}>
              <div className="flex">
                {convention.cover && (
                  <div
                    role="img"
                    className="w-20 h-20 max-h-full bg-shade-4 rounded bg-no-repeat bg-cover m-2"
                    style={{backgroundImage: `url(${convention.cover.url})`}}
                    aria-label={convention.name}
                  />
                )}
                <div className="px-2 py-3 flex flex-col">
                  <span className="font-semibold text-primary-12">{convention.name}</span>
                  <span className="flex gap-2 text-shade-11 text-sm items-center mt-1">
                    {truncate(convention.textDescription, 200)}
                  </span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </PublicLayout>
  );
}
